import {Injectable} from "@angular/core";
import {Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";
import {ToastrService} from "ngx-toastr";
import {TranslateService} from "@ngx-translate/core";


@Injectable()
export class NavigationGuard implements CanActivate
{


	/**
	 * Function > constructor
	 * @param OBJ_router
	 * @param OBJ_toastr_service
	 * @param OBJ_translate_service
	 */
	constructor(
		private OBJ_router: Router,
		private OBJ_toastr_service: ToastrService,
        private OBJ_translate_service: TranslateService
    ) {} // end function constructor


	/**
	 * Function > canActivate
	 * @param OBJ_route
	 * @param OBJ_state
	 * @return {boolean}
	 */
	canActivate(OBJ_route: ActivatedRouteSnapshot, OBJ_state: RouterStateSnapshot): boolean
	{

		if (localStorage.getItem("navigation"))
		{
			// Navigation in local Storage in so return true
			return true;
		} // end if

		// navigation not in local storage so redirect to client-selection page
		this.OBJ_router.navigate(["/client-selection"]);
		return false;

	} // end function canActivate


} // end function NavigationGuard